﻿import { mapGetters, mapState } from 'vuex';

export default {
  name: 'spotify-activation',
  props: ['blockId'],
  data: () => ({
    msisdn: '',
    inputValidationCode: '',
    showServerError: false,
    validationError: false,
    successResponseSendValidationCode: false,
    successResponseValidateValidationCode: false,
    validationCodeValidationError: false,
    token: '',
    spotifyActivationUrl: '',
    sendValidationResponseMessage: ''
  }),
  methods:
  {
    sendValidationCode: function () {
      this.resetStatusMessages();
      var mobileRegex = /^(?!\s*$)[0-9\s]{8}$/;
      if (this.msisdn && (mobileRegex.test(this.msisdn))) {
        this.validationError = false;
        var url = "/teliadk/SpotifyActivationLandingBlock/SendValidationCode/";
        var data = { msisdn: this.msisdn, blockId: this.blockId };
        var self = this;
        this.xmlPOST(url, data, function (oData) {
          self.successResponseSendValidationCode = oData.success;
          self.sendValidationResponseMessage = oData.message;
          self.showServerError = !oData.success
        });
      } else {
        this.validationError = true;
        var element = document.getElementById('PhoneNumber');
        if (element.classList.contains('service-registration-inputfield-error') == false) {
          element.classList.add('service-registration-inputfield-error');
        }
      }
    },
    validateValidationCode: function () {
      this.resetStatusMessages();
      if (this.inputValidationCode.length == 8) {
        var url = "/teliadk/SpotifyActivationLandingBlock/Validate/";
        var data = { phoneNumber: this.msisdn, pinCode: this.inputValidationCode, blockId: this.blockId };
        var self = this;
        this.xmlPOST(url, data, function (oData) {
          self.successResponseValidateValidationCode = oData.success;
          self.validationCodeValidationError = !oData.success;
          self.spotifyActivationUrl = oData.url;
          self.token = oData.token;
          if (self.spotifyActivationUrl != null) {
            window.location.replace(self.spotifyActivationUrl);
          }
        });
      } else {
        this.validationCodeValidationError = true;
        var element = document.getElementById('ValidationCode');
        if (element.classList.contains('service-registration-inputfield-error') == false) {

          element.classList.add('service-registration-inputfield-error');

        }
      }
    },
    resetStatusMessages: function () {
      this.showServerError = false;
      this.validationError = false;
      this.successResponseSendValidationCode = false;
      this.validationCodeValidationError = false;
      this.successResponseValidateValidationCode = false;
    },
    xmlPOST: function (url, object, callback) {
      var xmlhttp = new XMLHttpRequest();
      xmlhttp.open("POST", url);
      xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xmlhttp.send(JSON.stringify(object));

      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) {
          callback(JSON.parse(xmlhttp.response));
        }
      }
    }

  }
}